export default __webpack_public_path__ + "static/media/ic-art-detail-information.c08c840e.svg";